/* var Brand_lineCode = ; */
// var Brand_lineCode ='/assets/Brand_lineCode.json';
// console.log("Brand_lineCode>>>>>>>>>>>>>>>>>>",Brand_lineCode)

// Cache variables - ADD THESE AT THE TOP
var brandLineCodeCache = null;
var cachePromise = null;

// Function to load and cache the Brand Line Code data once
async function loadBrandLineCodeData() {
  // If data is already cached, return it
  if (brandLineCodeCache !== null) {
    return brandLineCodeCache;
  }
  
  // If a fetch is already in progress, wait for it
  if (cachePromise !== null) {
    return cachePromise;
  }
  
  // Start fetching the data
  cachePromise = (async () => {
    try {
      // var jsonUrl = `https://cdn.shopify.com/s/files/1/0638/4887/4142/t/12/assets/Brand_lineCode.json`;
      var jsonUrl = "//genuinereplacementparts.com/cdn/shop/t/110/assets/Brand_lineCode.json?v=111234140960566680491792579845";
      
      const response = await fetch(jsonUrl);
      const data = await response.json();
      
      // Cache the data
      brandLineCodeCache = data;
      return data;
    } catch (error) {
      console.error('Error fetching Brand_lineCode.json:', error);
      cachePromise = null; // Reset promise on error so it can retry
      return null;
    }
  })();
  
  return cachePromise;
}

var lineCode = '';
async function fetchBrandLineCode(productVendor) {
  // console.log("productVendor>>>>>productVendor<<<<",productVendor)
  
  if (!productVendor) return null;
  
  try {
    const data = await loadBrandLineCodeData();
    
    if (!data) {
      // console.log("No data available for brand lookup");
      return null;
    }
    
    const formatString = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    const matchingBrand = data.find(item => formatString(item.Brand) === formatString(productVendor));
    
    if (matchingBrand) {
      // console.log("Found Matching Brand:", matchingBrand);
      const lineCode = matchingBrand.lineCode;
      // console.log("Line Code:", lineCode);
      return lineCode;
    } else {
      // console.log("No matching brand found for vendor:", productVendor);
      return null;
    }
  } catch (error) {
    // console.log("catch fetchBrandLineCode")
    // console.error('Error fetching or processing Brand_lineCode.json:', error);
    return null;
  }
}

var lineCodeFoMuliBr = '';
async function fetchBrandLineCodeFoMuliBr(productVendorFoMuliBr) {
  
  if (!productVendorFoMuliBr) return null;
  
  try {
    const data = await loadBrandLineCodeData();
    
    if (!data) {
      // console.log("No data available for brand lookup");
      return null;
    }
    
    // console.log("productVendorFoMuliBr>>>>>productVendorFoMuliBr",productVendorFoMuliBr)
    const matchingBrand = data.find(item => item.Brand.toLowerCase() == productVendorFoMuliBr.toLowerCase());
    
    // console.log("matchingBrandFoMuliBr",matchingBrand)
    
    if (matchingBrand) {
      // console.log("Found Matching Brand:", matchingBrand);
      const lineCodeFoMuliBr = matchingBrand.lineCode;
      // console.log("Line Code FoMuliBr :>>>>>", lineCodeFoMuliBr);
      return lineCodeFoMuliBr;
    } else {
      // console.log("No matching brand found for vendor:", productVendorFoMuliBr);
      return null;
    }
  } catch (error) {
    // console.log("catch fetchBrandLineCodeFoMuliBr")
    // console.error('Error fetching or processing Brand_lineCode.json:', error);
    return null;
  }
}

function handleClick(element) {
  // console.log("this",element)
  var attrhandle = $(element).attr('attrhandle');
  // console.log("attrhandle",attrhandle)
  
  if (!attrhandle) {
    $('.loader_modelpage').addClass('loader_active');
    $('.template-product').addClass('body_blur');
    $('.template-page').addClass('body_blur');
    
    // console.log("inside the attrhandle");
    
    const handleCRT = $(element).attr('attrpartNo');
    // console.log("handleCRT", handleCRT);

    const productType = $(element).attr('productType');
    // console.log("productType")

    const parthandle = $(element).attr('parthandle');
    
    const basepnCRT = $(element).attr('basepncrt');
    // console.log("basepnCRT",basepnCRT)
    
    const vendorCRT = $(element).attr('vendorname');
    // console.log("vendorCRT", vendorCRT);
    
    const titleCRT = $(element).attr('titleCRT');
    // console.log("titleCRT", titleCRT);
    
    var priceCRT = $(element).attr('priceCRT');
    // console.log("priceCRT", priceCRT);
    
    var imgsrcCRT = $(element).attr('imgsrcCRT');
    // console.log("imgsrcCRT", imgsrcCRT);

    var productTagCRT = $(element).attr('product-tags');

    var desCRT = $(element).attr('desCRT');
    
    var addtocart = $(element).attr('actionCart');
    
    var data = {
      partMfgName: titleCRT,
      partNumber: handleCRT,
      productType: productType,
      barcode: basepnCRT,
      partdes: desCRT,
      parthandle: parthandle,
      partPrice: priceCRT,
      imagePath: imgsrcCRT,
      vendorname: vendorCRT,
      productTag: productTagCRT,
      AddTOCART: addtocart
    };
    
    // $('.loader_modelpage').show();  
    jQuery.ajax({
      url: `https://fridgeparts.us/grpapp/admin_ajax.php?action=findProduct`,
      type: 'POST',
      data: data,
      success: function(data) {
        // console.log("datadatadata>>>", data);
        var dataFHandle = JSON.parse(data);
        // console.log("dataFHandle",dataFHandle)
        var proHan = dataFHandle.product.handle;
        // console.log("proHan",proHan)
        
        var variantAddId = dataFHandle.product.variants[0].id;
        // console.log("variantId>>for Add to Cart",variantAddId)
        
        // $(element).attr("data-pid", variantAddId);
        // setTimeout(() => {
        // $(element).addClass('js_add_to_cart_button')
        // }, "1000");
        // console.log(">>>>",$(element).find('.add_to_cart_encompass').attr("data-pid", variantAddId))
        // alert($(element).find('.add_to_cart_encompass').attr("data-pid", variantAddId))
        
        if ($(element).hasClass('modellistpara')) {
          // console.log("Element has class modellistpara");
          
          // $(element).find('.newHandle').attr('href', proHan);

          // var HandleSearch = '/products/' + proHan;
          // console.log('HandleSearch:', HandleSearch);
          
          // var newHandleElement = $(element).find('.newhandleSearch');
          // console.log('Element found:', newHandleElement);
          
          // newHandleElement.attr('href', HandleSearch);
          // console.log('Updated href:', newHandleElement.attr('href'));

          // $('.loader_modelpage').addClass('loader_active');
          // $('.template-product').addClass('body_blur');

          // alert($(element).find('.add_to_cart_encompass').attr("data-pid", variantAddId))
          
          if ($(element).find('.newhandleSearch').length) {
            // console.log("Element has class newhandleSearch");
            // console.log("proHan>>>>>ifcondition",proHan)
            window.location.href = '/products/' + proHan;
          } else if ($(element).find('.newHandle').length) {
            // alert(window.location.href)
            // console.log("Element has class newHandle");
            // console.log("proHan>>>>>elsecondition",proHan)
            var url = window.location.href;
            var baseUrl = url.split('/products/')[0] + '/products/'+proHan;
            // alert(baseUrl)
            
            // window.location.href = proHan;
            window.location.href = baseUrl;
          }

          $('.loader_modelpage').removeClass('loader_active');
          $('.template-product').removeClass('body_blur');
          $('.template-page').removeClass('body_blur');
          // window.location.href = proHan;
        } else {
          // console.log("Element does not have class modellistpara");
          
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: variantAddId
            },
            success: function(response) {
              var responseData = JSON.parse(response);
              // console.log("responseData", responseData);
              $('.loader_modelpage').removeClass('loader_active');
              $('.template-product').removeClass('body_blur');
              $('.template-page').removeClass('body_blur');
              $(".toast_message_popup").removeClass('slideIn');
              $(".toast_message_popup .message").html('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 28 27" fill="none"><path d="M8.64799 20.7238C7.08486 20.7238 5.81776 21.991 5.81776 23.5541C5.81776 25.1172 7.08492 26.3843 8.64799 26.3843C10.2111 26.3843 11.4782 25.1171 11.4782 23.5541C11.4783 21.991 10.2111 20.7238 8.64799 20.7238ZM8.64799 25.1265C7.7796 25.1265 7.07565 24.4225 7.07565 23.5541C7.07565 22.6857 7.7796 21.9818 8.64799 21.9818C9.51639 21.9818 10.2203 22.6857 10.2203 23.5541C10.2204 24.4225 9.51639 25.1265 8.64799 25.1265ZM20.598 20.7238C19.0349 20.7238 17.7678 21.991 17.7678 23.5541C17.7678 25.1172 19.0349 26.3843 20.598 26.3843C22.1611 26.3843 23.4282 25.1171 23.4282 23.5541C23.4282 21.991 22.1611 20.7238 20.598 20.7238ZM20.598 25.1265C19.7296 25.1265 19.0257 24.4225 19.0257 23.5541C19.0257 22.6857 19.7296 21.9818 20.598 21.9818C21.4664 21.9818 22.1704 22.6857 22.1704 23.5541C22.1704 24.4225 21.4664 25.1265 20.598 25.1265ZM26.9818 4.214C26.8509 4.07095 26.6717 3.98135 26.4787 3.96239L6.00646 3.67937L5.44041 1.94975C5.04164 0.793514 3.9589 0.0129413 2.73592 0H0.628948C0.281579 0 0 0.281579 0 0.628948C0 0.976317 0.281579 1.2579 0.628948 1.2579H2.73592C3.06981 1.26528 3.39344 1.37472 3.6633 1.57148C3.93315 1.76825 4.13629 2.04293 4.24542 2.35857L8.23923 14.4029L7.92479 15.1262C7.7519 15.572 7.6874 16.0526 7.73661 16.5282C7.78582 17.0039 7.94732 17.4611 8.20781 17.8621C8.46567 18.2558 8.81473 18.5814 9.22534 18.8113C9.63595 19.0413 10.096 19.1687 10.5664 19.1829H22.7994C23.1468 19.1829 23.4284 18.9013 23.4284 18.5539C23.4284 18.2066 23.1468 17.925 22.7994 17.925H10.5663C10.3009 17.9183 10.0413 17.8459 9.81075 17.7142C9.58022 17.5824 9.38601 17.3955 9.24552 17.1702C9.10627 16.9472 9.01974 16.6952 8.99249 16.4337C8.96525 16.1721 8.99802 15.9078 9.0883 15.6607L9.3399 15.0947L22.5792 13.711C24.0335 13.5508 25.2297 12.4931 25.5668 11.0694L27.0763 4.7485C27.1097 4.65909 27.1185 4.56237 27.1019 4.46837C27.0853 4.37438 27.0438 4.28655 26.9818 4.214ZM24.3403 10.7864C24.1361 11.7029 23.358 12.3789 22.422 12.4532L9.3399 13.8054L6.41529 4.93727L25.6925 5.22029L24.3403 10.7864Z" fill="white"></path></svg>Product Added To Cart');
              $(".toast_message_popup").addClass('slideIn');
              setTimeout(function(){
                $(".toast_message_popup").removeClass('slideIn');

                var $minicart = $("#js_cart_popup");
                $.ajax({
                  async: false, 
                  cache: false,
                  url: Shopify.routes.root + 'cart?view=minicart',
                  type: 'GET',
                  dataType: 'html',
                  success: function (response) {
                    var cart = $(response);
                    if(cart.find('#MainContent').length) cart = cart.find('#MainContent');
                    $minicart.html(cart);
                    var data = cart.find('#json-data-cart');
                    data = JSON.parse(data.text());
                    $(".js-total-price").html(Shopify.formatMoney(data.total_price, theme.moneyFormat)).find('.money').css('opacity', '0').delay(500).fadeTo(50, 1);
                    $(".js-cart-count").html(data.item_count);
                    updateFreeShipping(data);
                    document.querySelector('body').dispatchEvent(new Event('contentUpdated'));
                    // $(document).find("#js_cart_popup").addClass(" act_opened");
                  },
                  error: function (request, status, error) {
                    window.location.reload();
                  }
                });
              },3000);
              // $(document).find("#js_cart_popup").addClass(" act_opened");
              // $('.loader_modelpage').hide();
              // window.location.reload();
            },
            error: function(xhr, status, error) {
              $('.loader_modelpage').removeClass('loader_active');
              $('.template-product').removeClass('body_blur');
              $('.template-page').removeClass('body_blur');
              // console.error("Error adding product to cart:", error);
            }
          });
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Handle the error here
        // console.error('AJAX error: ', textStatus, errorThrown);
        $('.loader_modelpage').removeClass('loader_active');
        $('.template-product').removeClass('body_blur');
        $('.template-page').removeClass('body_blur');
      }
    });
  } else {
    // console.log("Not Blank");
  }
}